import { Label } from "@/components/atoms/texts/label";
import { useConsultantContext } from "@/context/ConsultantContext";
import Action from "@/components/molecules/buttons/Action";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import PersonIcon from "@mui/icons-material/Person";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { useState, useEffect } from "react";

import DividerLight from "@/components/atoms/divider/dividerLight";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { ResizablePanel } from "@/components/ui/resizable";
import LineArt from "@/assets/images/lineArt.png";

import { useAuthContext } from '@/context/AuthContext';
import { ContentType } from "../MultiSelectorComponent";
import { useSelectedItems } from "@/context/SelectedItemsContext";
import { WarningRounded } from "@mui/icons-material";
import { format } from "date-fns"

export default function DetailsAboutConsultant() {
    const { activeUser, setActiveUser } = useConsultantContext();
    const { isAvailableRoute, isBrowsingAllowedTo, fullPath } = useAuthContext();
    const { selectedItems } = useSelectedItems(); // Récupération des éléments sélectionnés depuis le contexte
    const [itemActive, setItemActive] = useState(0);
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();

    useEffect(() => {
        // console.log("activeUser change activeUser id is ", activeUser)

    }, [activeUser]);

    const actions = [
        {
            icon: <ViewQuiltIcon />,
            text: "consultants.dashboard.tabs.statement",
            url: "./statement",
            type: ContentType.INVOICE,
        },

        {
            icon: <PersonIcon/>,
            text: "consultants.dashboard.tabs.information",
            url: "./information",
        },
        {
            icon: <ContactPageIcon />,
            text: "consultants.dashboard.tabs.cv",
            url: "./cv",
            variant: "disabled"
        },
        {
            icon: <RequestQuoteIcon />,
            text: "consultants.dashboard.tabs.payslip",
            url: "./payslip",
            type: ContentType.PAYSLIP,
        },
        {
            icon: <EventAvailableIcon />,
            text: "consultants.dashboard.tabs.timesheet",
            url: "./timesheet",
            type: ContentType.TIMESHEET,
            //   variant:"disabled"
        },
        // {
        //     icon: <AddTaskIcon />,
        //     text: "consultants.dashboard.tabs.skills",
        //     url: "./skills",
        //     variant: "disabled"

        // },
        {
            icon: <ShoppingCartIcon />,
            text: "consultants.dashboard.tabs.expense",
            url: "./expense",
            type: ContentType.EXPENSE,
        },
        {
            icon: <DirectionsCarIcon />,
            text: "consultants.dashboard.tabs.companyBenefits",
            url: "./companyBenefit",
            type: ContentType.COMPANY_BENEFIT,
        },{
            icon: <SavingsRoundedIcon />,
            text: "consultants.dashboard.tabs.overflow",
            url: "./overflow",
            // type: ContentType.INVOICE,
        },
    ];

    const handleClick = (index, url) => {
        console.log('handleClick', url);
        if (isBrowsingAllowedTo(fullPath('.' + url))) {
            setItemActive(index);
            navigate(url, { replace: true });
        }
    };

    // Lire le router et non window.location : pendant un changement de consultant, window.location
    // est deja a jour alors que id ne l'est pas encore, ce qui declenchait une redirection vers l'ancien id.
    const pathSegments = location.pathname.split("/");

    useEffect(() => {
        const isWellFormedUrl = pathSegments[1] === "consultant" &&
            pathSegments[2] === id &&
            [
                "statement",
                "information",
                "cv",
                "payslip",
                "timesheet",
                "skills",
                "expense",
                "companyBenefit",
                "overflow"
            ].includes(pathSegments[3]);

        if (isWellFormedUrl) return;

        for (let i = 0; i < actions.length; i++) {
            if (isBrowsingAllowedTo(fullPath(actions[i].url))) {
                navigate(actions[i].url);
                break;
            }
        }
    }, [location.pathname, id]);
    // console.log("DetailsAboutConsultant lastElementOfURL= " , lastElementOfURL)

    return (
        <ResizablePanel
            defaultSize={85}
            className="h-full z-10"
            id="details-panel"
            order={2}
        >
            <div className="flex flex-col p-secondDegree  h-full  ">
                <div className="overflow-auto ">
                    <img src={LineArt} onDragStart={(e)=> e.preventDefault()}  className="bgLineArt" />

                    {activeUser && (
                        <div className="flex flex-row p-paddingTopAndBottom items-center gap-betweenText">
                            <Label size="h3" fontWeight="bold">
                                {activeUser.firstname + " " + activeUser.lastname}
                            </Label>
                            <span> - </span>
                            <Label size="body" fontWeight="">
                                {activeUser.trigram}
                            </Label>
                            {activeUser.leaveDate && <span className="mx-2 py-1 px-3 bg-warning rounded-full inline-flex items-center gap-betweenText">
                                <WarningRounded />
                                <Label size="body" message="consultants.informations.leaveDate" />:
                                <Label size="body" fontWeight="bold" >
                                    {format(activeUser?.leaveDate,"dd/MM/yyyy")}
                                </Label>
                            </span>}


                        </div>
                    )}





                    <div className="grid grid-cols-8 gap-4 %+ml; overflow-auto">
                        {actions.map((action, index) => {
                            const badgeCount = action.type
                                ? selectedItems.filter(
                                    (item) =>
                                        item.type === action.type && item.idConsultant === id // Filtre par type et idConsultant
                                ).length
                                : 0;

                            return (
                                <Action
                                    key={index}
                                    icon={action.icon}
                                    text={action.text}
                                    alwaysShowText={true}
                                    initialVariant={
                                        !isBrowsingAllowedTo(fullPath('.' + action.url)) ? "disabled" :
                                            action.variant ||
                                            ("./" + pathSegments[3] === action.url ? "active" : "default")
                                    }
                                    className="gap-0 space-y-3 py-3"
                                    {...(badgeCount > 0 && { badge: badgeCount })} // Envoi de badge uniquement si > 0
                                    onClickAction={() => handleClick(index, action.url)}
                                />
                            );
                        })}
                    </div>
                    <DividerLight className="" />

                    <Outlet />
                </div>
            </div>
        </ResizablePanel>
    );
}
